import React, { useState } from 'react';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose, title, children }) => {
  const [isFullScreen, setFullScreen] = useState(false);

  // هنگام بستن سایدبار، حالت تمام‌صفحه هم ریست می‌شود
  const handleClose = () => {
    setFullScreen(false);
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  // کلاس 'fullscreen' به صورت داینامیک اضافه می‌شود
  const containerClass = isFullScreen ? 'sidebar-container fullscreen' : 'sidebar-container';

  return (
    <>
      <div className="sidebar-overlay" onClick={handleClose}></div>
      <div className={containerClass}>
        <div className="sidebar-header">
          <h2>{title}</h2>
          <div className="header-buttons">
            <button onClick={() => setFullScreen(!isFullScreen)} className="fullscreen-btn" title="تمام صفحه">
              {isFullScreen ? ' کوچک‌سازی ↘' : ' بزرگ‌نمایی ↗'}
            </button>
            <button onClick={handleClose} className="close-btn">
              &times;
            </button>
          </div>
        </div>
        <div className="sidebar-content">
          {children}
        </div>
      </div>
    </>
  );
};

export default Sidebar;